import React, { useEffect } from 'react'
import map from 'lodash/map'
import { Route, Routes, useLocation, useNavigate, Navigate } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'

import { useAuth0 } from '@auth0/auth0-react'
import useInnovaAuth from 'components/common/hooks/useInnovaAuth'
import { userRoleSelector } from 'atoms'
import { useRecoilValue } from 'recoil'
import { addItemToLS } from 'utils/localStorage'

const AUTH_HOME_ROUTE = '/well-list'

const MainRouter = ({ children, publicRoutes, privateRoutes }) => {
  const unlisten = React.useRef(null)
  const { isAuthenticated, user, isLoading } = useAuth0()
  let location = useLocation()
  const navigate = useNavigate()
  const { setUser } = useInnovaAuth()
  const userRole = useRecoilValue(userRoleSelector)
  const authTypeInnova = typeof userRole?.authType === 'string' && userRole?.authType?.toLowerCase() === 'innova'
  const pwdResetReq = userRole?.passwordResetRequired

  const redirectToHome = (isAuthenticated, pathname, forceResetPwd) => {
    if (isAuthenticated && pathname === '/' && !forceResetPwd) {
      navigate(AUTH_HOME_ROUTE)
    }
    if (isAuthenticated && forceResetPwd) {
      navigate('/reset-password')
    }
  }

  useEffect(() => {
    if (isLoading) return

    const forceResetPwd = authTypeInnova && pwdResetReq

    unlisten.current = (location) => {
      if (location) redirectToHome(isAuthenticated, location.pathname, forceResetPwd)
    }

    if (isAuthenticated && user) {
      const isEmail = (val) => typeof val === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)

      let resolvedName = user.name || ''
      if (!isEmail(resolvedName)) {
        if (isEmail(user.email)) {
          resolvedName = user.email
        } else if (isEmail(user.preferred_username)) {
          resolvedName = user.preferred_username
        }
      }
      setUser({ name: resolvedName })
      addItemToLS('userName', 'userName', resolvedName)
    }

    if (location && (!user || !user.name)) return
    if (location) redirectToHome(isAuthenticated, location.pathname, forceResetPwd)

    return () => {
      unlisten.current()
    }
  }, [isAuthenticated, user, setUser, pwdResetReq, authTypeInnova]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      {children}
      <Routes>
        {map(publicRoutes, ({ path, Component }) => {
          return <Route key={path} path={path} element={<Component />} />
        })}
        {map(privateRoutes, ({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <PrivateRoute>
                <Component />
              </PrivateRoute>
            }
          />
        ))}
        <Route path='*' element={<Navigate to='/well-list' replace />} />
      </Routes>
    </React.Fragment>
  )
}

export default MainRouter
